

// import React, { useState, useEffect } from "react";
// import { useHistory, useLocation, useParams } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import Spinner from "react-bootstrap/Spinner";
// import { Smartphone, Lock, ShieldCheck, ArrowRight, RefreshCw } from "lucide-react";
// import { apiRequest } from "../../apiService/allApi";
// import "react-toastify/dist/ReactToastify.css";
// // import "./Login.css";

// export default function Login() {
//   const history = useHistory();
//   const location = useLocation();
//   const { referralcode } = useParams();

//   const [Phone, setPhone] = useState("");
//   const [twofactor_code, settwofactor_code] = useState("");
//   const [otp, setOtp] = useState(false);
//   const [isLoading1, setIsloading1] = useState(false);
//   const [secretCode, setSecretCode] = useState();
//   const [isValid, setIsValid] = useState(false);
//   const [seconds, setSeconds] = useState(60);

//   const referral = referralcode || location.pathname.split("/")[2] || "";

//   useEffect(() => {
//     let timerInterval;
//     if (isValid && seconds > 0) {
//       timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
//     } else {
//       clearInterval(timerInterval);
//       setIsValid(false);
//     }
//     return () => clearInterval(timerInterval);
//   }, [isValid, seconds]);

//   const handleClick = async (e) => {
//     e?.preventDefault();
//     if (!Phone || Phone.length !== 10) {
//       return toast.error("Please enter a valid 10-digit mobile number.", {
//         position: "top-center",
//         theme: "dark",
//       });
//     }

//     setIsloading1(true);
//     const respone = await apiRequest("login", "POST", { Phone, referral });
//     setIsloading1(false);

//     if (respone?.data?.status === 200) {
//       setOtp(true);
//       setIsValid(true);
//       setSeconds(60);
//       setSecretCode(respone?.data?.secret);
      
//       toast.success("OTP sent successfully!", { position: "top-center", theme: "dark" });

//       if (respone?.data?.myToken) {
//         toast.info(`Demo OTP: ${respone?.data?.myToken}`, {
//           position: "top-center",
//           autoClose: 10000,
//           theme: "dark",
//         });
//       }
//     } else {
//       toast.error(respone?.data?.msg || "Login failed. Please try again.", {
//         position: "top-center",
//         theme: "dark",
//       });
//     }
//   };

//   const varifyOtp = async (e) => {
//     e.preventDefault();
//     setIsloading1(true);
//     try {
//       const response = await apiRequest("login/finish", "POST", {
//         Phone,
//         twofactor_code,
//         referral,
//         secretCode,
//       });
//       setIsloading1(false);

//       if (response?.data?.status === 200) {
//         toast.success("Verification successful! Redirecting...", {
//           position: "top-center",
//           theme: "dark",
//         });
//         localStorage.setItem("token", response?.data?.token);
//         setTimeout(() => {
//           window.location.reload(true);
//           history.push("/Games");
//         }, 1000);
//       } else {
//         toast.error(response?.data?.msg || "Invalid OTP. Please try again.", {
//           position: "top-center",
//           theme: "dark",
//         });
//       }
//     } catch (error) {
//       setIsloading1(false);
//       toast.error("Error verifying OTP. Please try again.", {
//         position: "top-center",
//         theme: "dark",
//       });
//     }
//   };

//   return (
//     <div className="classic-page-wrapper">
//       <ToastContainer limit={3} />
      
//       {/* Background ambient lighting elements */}
//       <div className="ambient-glow glow-1"></div>
//       <div className="ambient-glow glow-2"></div>

//       <div className="classic-card">
//         {/* Top Branding Section */}
//         <div className="classic-header">
//           <div className="logo-badge">
//             <img src="/mplbets.png" alt="MPLBETS" className="brand-logo" />
//           </div>
//           <h2 className="brand-title">Welcome Back</h2>
//           <p className="brand-subtitle">
//             {otp ? "Enter the verification code sent to your phone" : "Enter your mobile number to get started"}
//           </p>
//         </div>

//         {/* Input Form */}
//         <form onSubmit={otp ? varifyOtp : handleClick} className="classic-form">
//           <div className="input-field-group">
//             <label className="field-label">Mobile Number</label>
//             <div className={`input-wrapper ${otp ? "readonly" : ""}`}>
//               <span className="country-tag">+91</span>
//               <input
//                 type="tel"
//                 className="classic-input"
//                 placeholder="98765 43210"
//                 value={Phone}
//                 disabled={otp}
//                 onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))}
//                 required
//               />
//               <Smartphone className="input-icon" size={18} />
//             </div>
//           </div>

//           {otp && (
//             <div className="input-field-group animate-slide-up">
//               <div className="label-row">
//                 <label className="field-label">Verification OTP</label>
//                 <span className="security-badge">
//                   <ShieldCheck size={14} /> Encrypted
//                 </span>
//               </div>
//               <div className="input-wrapper">
//                 <input
//                   type="text"
//                   className="classic-input otp-input"
//                   placeholder="• • • • • •"
//                   maxLength={6}
//                   onChange={(e) => settwofactor_code(e.target.value)}
//                   required
//                   autoFocus
//                 />
//                 <Lock className="input-icon" size={18} />
//               </div>

//               {/* Timer & Resend Option */}
//               <div className="timer-container">
//                 {seconds > 0 ? (
//                   <span className="timer-text">
//                     Resend available in <strong>{seconds}s</strong>
//                   </span>
//                 ) : (
//                   <button
//                     type="button"
//                     className="resend-btn"
//                     onClick={handleClick}
//                     disabled={isLoading1}
//                   >
//                     <RefreshCw size={14} /> Resend OTP
//                   </button>
//                 )}
//               </div>
//             </div>
//           )}

//           {/* Action Button */}
//           <button type="submit" className="classic-submit-btn" disabled={isLoading1}>
//             {isLoading1 ? (
//               <Spinner animation="border" size="sm" />
//             ) : (
//               <>
//                 <span>{otp ? "Verify & Continue" : "Send OTP"}</span>
//                 <ArrowRight size={18} />
//               </>
//             )}
//           </button>
//         </form>

//         {/* Footer info */}
//         <div className="classic-footer">
//           <p>Protected by end-to-end security protocol</p>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { Smartphone, Lock, ShieldCheck, ArrowRight, RefreshCw } from "lucide-react";
import { apiRequest } from "../../apiService/allApi";
import "../css/login.css"

export default function Login() {
  const history = useHistory();
  const location = useLocation();
  const { referralcode } = useParams();

  const [Phone, setPhone] = useState("");
  const [twofactor_code, settwofactor_code] = useState("");
  const [otp, setOtp] = useState(false);
  const [isLoading1, setIsloading1] = useState(false);
  const [secretCode, setSecretCode] = useState();
  const [isValid, setIsValid] = useState(false);
  const [seconds, setSeconds] = useState(60);

  const otpInputRef = useRef(null);

  const referral = referralcode || location.pathname.split("/")[2] || "";

  // Timer logic for OTP Resend
  useEffect(() => {
    let timerInterval;
    if (isValid && seconds > 0) {
      timerInterval = setInterval(() => setSeconds((prev) => prev - 1), 1000);
    } else {
      clearInterval(timerInterval);
      setIsValid(false);
    }
    return () => clearInterval(timerInterval);
  }, [isValid, seconds]);

  // Web OTP API Support (Auto-fill SMS OTP on mobile browsers)
  useEffect(() => {
    if (otp && "OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otpObj) => {
          if (otpObj && otpObj.code) {
            settwofactor_code(otpObj.code);
            // SweetAlert notification when auto-filled
            Swal.fire({
              toast: true,
              position: "top",
              icon: "info",
              title: "OTP Auto-filled from SMS!",
              showConfirmButton: false,
              timer: 3000,
              background: "#1e1e2d",
              color: "#ffffff",
            });
          }
        })
        .catch(() => {
          // Fallback gracefully if OTP retrieval fails or user cancels
        });

      return () => ac.abort();
    }
  }, [otp]);

  // Handle Requesting OTP
  const handleClick = async (e) => {
    e?.preventDefault();
    if (!Phone || Phone.length !== 10) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number.",
        background: "#181824",
        color: "#ffffff",
        confirmButtonColor: "#6366f1",
      });
    }

    setIsloading1(true);
    const respone = await apiRequest("login", "POST", { Phone, referral });
    setIsloading1(false);

    if (respone?.data?.status === 200) {
      setOtp(true);
      setIsValid(true);
      setSeconds(60);
      setSecretCode(respone?.data?.secret);

      let textMsg = "Verification code has been send.";
      if (respone?.data?.myToken) {
        textMsg += `\n\nDemo OTP: ${respone?.data?.myToken}`;
      }

      Swal.fire({
        icon: "success",
        title: "OTP Sent!",
        text: textMsg,
        background: "#181824",
        color: "#ffffff",
        confirmButtonColor: "#6366f1",
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: respone?.data?.msg || "Login failed. Please try again.",
        background: "#181824",
        color: "#ffffff",
        confirmButtonColor: "#ef4444",
      });
    }
  };

  // Handle Verifying OTP
  const varifyOtp = async (e) => {
    e.preventDefault();
    setIsloading1(true);
    try {
      const response = await apiRequest("login/finish", "POST", {
        Phone,
        twofactor_code,
        referral,
        secretCode,
      });
      setIsloading1(false);

      if (response?.data?.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Verified!",
          text: "Verification successful! Redirecting...",
          timer: 1500,
          showConfirmButton: false,
          background: "#181824",
          color: "#ffffff",
        });

        localStorage.setItem("token", response?.data?.token);
        setTimeout(() => {
          window.location.reload(true);
          history.push("/Games");
        }, 1000);
      } else {
        Swal.fire({
          icon: "error",
          title: "Verification Failed",
          text: response?.data?.msg || "Invalid OTP. Please try again.",
          background: "#181824",
          color: "#ffffff",
          confirmButtonColor: "#ef4444",
        });
      }
    } catch (error) {
      setIsloading1(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error verifying OTP. Please try again.",
        background: "#181824",
        color: "#ffffff",
        confirmButtonColor: "#ef4444",
      });
    }
  };

  return (
    <div className="classic-page-wrapper">
      {/* Dynamic Background Glow Elements */}
      <div className="ambient-glow glow-1"></div>
      <div className="ambient-glow glow-2"></div>
      <div className="ambient-glow glow-3"></div>

      <div className="classic-card">
        {/* Top Branding Section */}
        <div className="classic-header">
          <div className="logo-badge">
            <img src="/mplbets.png" alt="MPLBETS" className="brand-logo" />
          </div>
          <h2 className="brand-title">Welcome Back</h2>
          <p className="brand-subtitle">
            {otp
              ? "Enter the 6-digit verification code sent to your phone"
              : "Enter your 10-digit mobile number to get started"}
          </p>
        </div>

        {/* Input Form */}
        <form onSubmit={otp ? varifyOtp : handleClick} className="classic-form">
          <div className="input-field-group">
            <label className="field-label">Mobile Number</label>
            <div className={`input-wrapper ${otp ? "readonly" : ""}`}>
              <span className="country-tag">+91</span>
              <input
                type="tel"
                className="classic-input"
                placeholder="Enter Phone Number"
                value={Phone}
                disabled={otp}
                onChange={(e) =>
                  setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
                }
                required
              />
              <Smartphone className="input-icon" size={18} />
            </div>
          </div>

          {otp && (
            <div className="input-field-group animate-slide-up">
              <div className="label-row">
                <label className="field-label">Verification OTP</label>
                <span className="security-badge">
                  <ShieldCheck size={14} /> Encrypted
                </span>
              </div>
              <div className="input-wrapper">
                <input
                  ref={otpInputRef}
                  type="text"
                  className="classic-input otp-input"
                  placeholder="• • • • • •"
                  maxLength={6}
                  value={twofactor_code}
                  autoComplete="one-time-code"
                  inputMode="numeric"
                  onChange={(e) =>
                    settwofactor_code(
                      e.target.value.replace(/\D/g, "").slice(0, 6)
                    )
                  }
                  required
                  autoFocus
                />
                <Lock className="input-icon" size={18} />
              </div>

              {/* Timer & Resend Option */}
              <div className="timer-container">
                {seconds > 0 ? (
                  <span className="timer-text">
                    Resend available in <strong>{seconds}s</strong>
                  </span>
                ) : (
                  <button
                    type="button"
                    className="resend-btn"
                    onClick={handleClick}
                    disabled={isLoading1}
                  >
                    <RefreshCw size={14} className={isLoading1 ? "spin" : ""} />{" "}
                    Resend OTP
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Action Button */}
          <button
            type="submit"
            className="classic-submit-btn"
            disabled={isLoading1}
          >
            {isLoading1 ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <>
                <span>{otp ? "Verify & Continue" : "Send OTP"}</span>
                <ArrowRight size={18} />
              </>
            )}
          </button>
        </form>

        {/* Footer info */}
        <div className="classic-footer">
          <p>Protected by end-to-end security protocol</p>
        </div>
      </div>
    </div>
  );
}